import { inject, toRef, computed, watch, openBlock, createElementBlock, withModifiers, normalizeClass, unref, toDisplayString, createCommentVNode, createElementVNode } from "vue";
import { useField } from "vee-validate";
/* empty css               */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = { class: "switch" };
const _hoisted_2 = ["checked", "name"];
const _sfc_main = {
  __name: "Switch",
  props: {
    name: {
      type: String,
      required: true
    },
    rules: {
      type: [String, Object],
      default: void 0
    },
    wording1: {
      type: String,
      default: ""
    },
    wording2: {
      type: String,
      default: ""
    },
    hasUnCheckedState: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "toggle"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const isFormDisabled = inject("isFormDisabled", false);
    const emit = __emit;
    const name = toRef(props, "name");
    const { value, handleBlur, handleChange } = useField(name, props.rules, {
      initialValue: props.modelValue
    });
    const isDisabled = computed(() => isFormDisabled.value || props.disabled);
    const handleClick = () => {
      if (!isDisabled.value) {
        const newValue = !value.value;
        handleChange(newValue);
        emit("update:modelValue", newValue);
        emit("toggle", newValue);
      }
    };
    watch(
      () => props.modelValue,
      (newValue) => {
        if (value.value !== newValue) {
          handleChange(newValue);
        }
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "hz-switch",
        onClick: withModifiers(handleClick, ["prevent"])
      }, [
        __props.wording1 ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["label u-mr-sm", { active: !unref(value) }])
        }, toDisplayString(__props.wording1), 3)) : createCommentVNode("", true),
        createElementVNode("label", _hoisted_1, [
          createElementVNode("input", {
            checked: unref(value),
            name: name.value,
            type: "checkbox",
            onClick: handleClick,
            onBlur: _cache[0] || (_cache[0] = (...args) => unref(handleBlur) && unref(handleBlur)(...args))
          }, null, 40, _hoisted_2),
          createElementVNode("span", {
            class: normalizeClass(["slider", { grey: __props.hasUnCheckedState && !unref(value) }])
          }, null, 2)
        ]),
        __props.wording2 ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["label u-ml-sm", { active: unref(value) }])
        }, toDisplayString(__props.wording2), 3)) : createCommentVNode("", true)
      ]);
    };
  }
};
const Switch = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-5db3d214"]]);
export {
  Switch as default
};
//# sourceMappingURL=Switch.vue.es.js.map
